import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy ">
      <div className="container">
        <h1>Политика обработки персональных данных</h1>

        <section className="policy-section">
          <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
          <p>
            1.1 ООО ООО "КОДЕКСТЕХ" (далее по тексту – Оператор) ставит
            соблюдение прав и свобод граждан одним из важнейших условий
            осуществления своей деятельности.
          </p>
          <p>
            1.2 Политика Оператора в отношении обработки персональных данных
            (далее по тексту — Политика) применяется ко всей информации, которую
            Оператор может получить о посетителях веб-сайта
            https://codextech.ru. Персональные данные обрабатывается в
            соответствии с ФЗ «О персональных данных» № 152-ФЗ.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. ОСНОВНЫЕ ПОНЯТИЯ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ</h2>
          <p>
            2.1 Веб-сайт - совокупность графических и информационных материалов,
            а также программ для ЭВМ и баз данных, обеспечивающих их доступность
            в сети интернет по сетевому адресу https://codextech.ru;
          </p>
          <p>
            2.2 Пользователь – любой посетитель веб-сайта https://codextech.ru;
          </p>
          <p>
            2.3 Персональные данные – любая информация, относящаяся к
            Пользователю веб-сайта https://codextech.ru;
          </p>
          <p>
            2.4 Обработка персональных данных - любое действие с персональными
            данными, совершаемые с использованием ЭВМ, равно как и без их
            использования;
          </p>
          <p>
            2.5 Обезличивание персональных данных – действия, результатом
            которых является невозможность без использования дополнительной
            информации определить принадлежность персональных данных конкретному
            Пользователю или лицу;
          </p>
          <p>
            2.6 Распространение персональных данных – любые действия,
            результатом которых является раскрытие персональных данных
            неопределенному кругу лиц;
          </p>
          <p>
            2.7 Предоставление персональных данных – любые действия, результатом
            которых является раскрытие персональных данных определенному кругу
            лиц;
          </p>
          <p>
            2.8 Уничтожение персональных данных – любые действия, результатом
            которых является безвозвратное уничтожение персональных на ЭВМ или
            любых других носителях.
          </p>
        </section>

        <section className="policy-section">
          <h2>3. ОПЕРАТОР МОЖЕТ ОБРАБАТЫВАТЬ СЛЕДУЮЩИЕ ДАННЫЕ</h2>
          <p>3.1. Адрес электронной почты Пользователя</p>
          <p>3.2. Номер телефона Пользователя</p>
          <p>3.3. Фамилию, имя, отчество Пользователя</p>
          <p>
            3.4. Также на сайте происходит сбор и обработка обезличенных данных
            о посетителях (в т.ч. файлов «cookie») с помощью сервисов
            интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).
          </p>
        </section>

        <section className="policy-section">
          <h2>4. ЦЕЛИ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
          <p>
            4.1. Цель обработки адреса электронной почты, номера телефона,
            фамилии, имени, отчества Пользователя - уточнение деталей заказа.
            Также Оператор имеет право направлять Пользователю уведомления о
            новых продуктах и услугах, специальных предложениях и различных
            событиях. Пользователь всегда может отказаться от получения
            информационных сообщений, направив Оператору письмо на адрес
            info@codextech.ru
          </p>
          <p>
            4.2. Обезличенные данные Пользователей, собираемые с помощью
            сервисов интернет-статистики, служат для сбора информации о
            действиях Пользователей на сайте, улучшения качества сайта и его
            содержания.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. ПРАВОВЫЕ ОСНОВАНИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ</h2>
          <p>
            5.1 Оператор обрабатывает персональные данные Пользователя только в
            случае их отправки Пользователем через формы, расположенные на сайте
            https://codextech.ru. Отправляя свои персональные данные Оператору,
            Пользователь выражает свое согласие с данной Политикой.
          </p>
          <p>
            5.2 Оператор обрабатывает обезличенные данные о Пользователе в
            случае, если это разрешено в настройках браузера Пользователя
            (включено сохранение файлов «cookie» и использование технологии
            JavaScript).
          </p>
        </section>

        <section className="policy-section">
          <h2>
            6. ПОРЯДОК СБОРА, ХРАНЕНИЯ, ПЕРЕДАЧИ И ДРУГИХ ВИДОВ ОБРАБОТКИ
            ПЕРСОНАЛЬНЫХ ДАННЫХ
          </h2>
          <p>
            6.1 Оператор обеспечивает сохранность персональных данных и
            принимает все возможные меры, исключающие доступ к персональным
            данным неуполномоченных лиц.
          </p>
          <p>
            6.2 Персональные данные Пользователя никогда, ни при каких условиях
            не будут переданы третьим лицам, за исключением случаев, связанных с
            исполнением действующего законодательства.
          </p>
          <p>
            6.3. В случае выявления неточностей в персональных данных,
            Пользователь может актуализировать их, направив Оператору
            уведомление с помощью электронной почты на электронный адрес
            Оператора info@codextech.ru.
          </p>
          <p>
            6.4 Срок обработки персональных данных является неограниченным.
            Пользователь может в любой момент отозвать свое согласие на
            обработку персональных данных, направив Оператору уведомление с
            помощью электронной почты на электронный адрес Оператора
            info@codextech.ru.
          </p>
        </section>

        <section className="policy-section">
          <h2>7. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>
          <p>
            7.1. Пользователь может получить любые разъяснения по интересующим
            вопросам, касающимся обработки его персональных данных, обратившись
            к Оператору с помощью электронной почты info@codextech.ru.
          </p>
          <p>
            7.2. В данном документе будут отражены любые изменения политики
            обработки персональных данных Оператором. В случае существенных
            изменений Пользователю может быть выслана информация на указанный им
            электронный адрес.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
